import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ooh/ui/components/button';

interface OfferListPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function OfferListPagination({ page, totalPages, onPageChange }: OfferListPaginationProps) {
  const { t } = useTranslation('offers');

  if (totalPages <= 1) return null;

  return (
    <div
      className="flex items-center justify-between border-t border-border bg-background px-6 py-3"
      data-testid="offer-list-pagination"
    >
      <span className="text-[13px] text-muted-foreground">
        {t('list.pagination.status', { page, total: totalPages })}
      </span>
      <div className="flex items-center gap-2">
        <Button
          aria-label={t('list.pagination.prev')}
          data-testid="offer-list-pagination-prev"
          disabled={page <= 1}
          size="sm"
          type="button"
          variant="outline"
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <Button
          aria-label={t('list.pagination.next')}
          data-testid="offer-list-pagination-next"
          disabled={page >= totalPages}
          size="sm"
          type="button"
          variant="outline"
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
